export const preloadImage=imageUri=>{try{const img=new Image;img.src=imageUri}catch(e){console.error("Image preload: ",e)}};